import { useEffect } from 'react';

export default function HideBadgeOnMobile() {
  useEffect(() => {
    const hideBadge = () => {
      // Hide the Emergent badge on ALL viewports
      const badge = document.getElementById('emergent-badge');
      if (badge) badge.style.display = 'none';
      
      // Fallback: find by style attributes
      const elements = document.querySelectorAll('a[href*="emergent"]');
      elements.forEach(el => {
        const style = el.getAttribute('style') || '';
        if (style.includes('position: fixed') || style.includes('position:fixed')) {
          el.style.display = 'none';
        }
      });
    };

    hideBadge();
    const interval = setInterval(hideBadge, 1000);
    return () => clearInterval(interval);
  }, []);

  return null;
}
